export default __webpack_public_path__ + "facetime-button.png";